// src/components/SkipLink.jsx
//
// Accessibility skip link. Hidden visually until focused; jumps the
// keyboard user past the header/rail navigation straight to the main
// content. Render once, near the top of the app tree.

import React from 'react';
import { Box } from '@mui/material';

const SkipLink = ({ targetId = 'main-content', label = 'Skip to main content' }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const el = document.getElementById(targetId);
    if (!el) return;
    el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: false });
    // Clean up the tabindex after blur so the element remains semantic.
    const cleanup = () => {
      el.removeAttribute('tabindex');
      el.removeEventListener('blur', cleanup);
    };
    el.addEventListener('blur', cleanup);
  };

  return (
    <Box
      component="a"
      href={`#${targetId}`}
      onClick={handleClick}
      sx={{
        position: 'fixed',
        top: 8,
        left: 8,
        zIndex: (t) => t.zIndex.tooltip + 10,
        px: 2,
        py: 1,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: 1,
        fontWeight: 600,
        fontSize: '0.875rem',
        textDecoration: 'none',
        boxShadow: 3,
        transform: 'translateY(-200%)',
        transition: 'transform 140ms ease',
        '&:focus': { transform: 'translateY(0)', outline: '2px solid', outlineOffset: 2 },
        '&:focus-visible': { transform: 'translateY(0)' },
      }}
    >
      {label}
    </Box>
  );
};

export default SkipLink;
